import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';
import MainLayout from './components/MainLayout';
import Document from './components/Pages/Document/Document';
import DocumentRPD from './components/Pages/Document/DocumentRPD';
import Code from './components/Pages/Code/Code';
import Home from './components/Home';
import Read from './components/Pages/Read/Read';
import reportWebVitals from './reportWebVitals';
import Error from './components/Pages/Exceptions/Default/Error';
import MaxReadMessage from './components/Pages/Exceptions/Default/MaxReadMessage'
import ExpireMessage from './components/Pages/Exceptions/Default/ExpireMessage';
import LaunchMessage from './components/Pages/Exceptions/Default/LaunchMessage';
import NoInternet from './components/Pages/Exceptions/Default/NoInternet';
import NoLongerAvailable from './components/Pages/Exceptions/Default/NoLongerAvailable';
import Printing from './components/Pages/Exceptions/Default/Printing';
import Restricted from './components/Pages/Exceptions/Default/Restricted';
import DocumentAccess from './components/Pages/Exceptions/Default/DocumentAccess';
import ReaderAccess from './components/Pages/Exceptions/Default/ReaderAccess';
import NoAccessMessage from './components/Pages/Exceptions/Default/NoAccess';
import NoPlan from './components/Pages/Exceptions/Default/NoPlan';
import MaxReadDocument from './components/Pages/Exceptions/Default/MaxReadDocument';
import SecurityAlert from './components/Pages/Exceptions/Default/SecurityAlert';
import BotMessage from './components/Pages/Exceptions/Default/BotMessage';
import AccessDenied from './components/Pages/Exceptions/Default/AccessDenied';

import XeroxError from './components/Pages/Exceptions/Xerox/Error';
import XeroxMaxReadMessage from './components/Pages/Exceptions/Xerox/MaxReadMessage'
import XeroxExpireMessage from './components/Pages/Exceptions/Xerox/ExpireMessage';
import XeroxLaunchMessage from './components/Pages/Exceptions/Xerox/LaunchMessage';
import XeroxNoInternet from './components/Pages/Exceptions/Xerox/NoInternet';
import XeroxNoLongerAvailable from './components/Pages/Exceptions/Xerox/NoLongerAvailable';
import XeroxPrinting from './components/Pages/Exceptions/Xerox/Printing';
import XeroxRestricted from './components/Pages/Exceptions/Xerox/Restricted';
import XeroxDocumentAccess from './components/Pages/Exceptions/Xerox/DocumentAccess';
import XeroxReaderAccess from './components/Pages/Exceptions/Xerox/ReaderAccess';
import XeroxNoAccessMessage from './components/Pages/Exceptions/Xerox/NoAccess';
import XeroxSessionExpire from './components/Pages/Exceptions/Xerox/SessionExpireMessage';
import SessionExpire from './components/Pages/Exceptions/Default/SessionExpireMessage';
import NoDocument from './components/Pages/Exceptions/Default/NoDocument';
import XeroxNoDocument from './components/Pages/Exceptions/Xerox/NoDocument';
import XeroxNoPlan from './components/Pages/Exceptions/Xerox/NoPlan';
import XeroxNoMaxReadDocument from './components/Pages/Exceptions/Xerox/MaxReadDocument';
import XeroxBotMessage from './components/Pages/Exceptions/Xerox/BotMessage';

import RpdUpload from './components/Pages/IOS/RpdUpload';

import "../src/Shared/Css/bootstrap.min.css";
import "../src/Shared/Css/bootstrap.bundle.js";
import "../src/Shared/Css/fonts.Robot.css";
import "../src/Shared/Css/fonts.icon.css";
import "../src/Shared/Css/signin.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <>
  
  <BrowserRouter>
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/read/:documentId/:openId/:docType" element={<Document />} />
        <Route path="/read/:documentId/:openId" element={<DocumentRPD />} />
        <Route path="/read/:documentId" element={<Document />} />
        <Route path="/code/:documentId/:typeId" element={<Code />} /> 
        <Route path="/code/:documentId/:typeId/:fileName" element={<Code />} />
        <Route path="/code/:documentId/:typeId/:level/:fileName" element={<Code />} />
        <Route path="/read" element={<Read />} />
        <Route path="/home" element={<Home />} />
        <Route path="/rpdupload/:documentId/:typeId" element={<RpdUpload />} />

        <Route path="/Default/Error" element={<Error />} />
        <Route path="/Default/MaxReadMessage/:documentId/:fileName" element={<MaxReadMessage />} />
        <Route path="/Default/NoAccess/:documentId/:fileName" element={<NoAccessMessage />} />
        <Route path="/Default/ExpireMessage/:documentId/:fileName" element={<ExpireMessage />} />
        <Route path="/Default/LaunchMessage/:documentId/:fileName/:launchDate/:launchTime" element={<LaunchMessage />} />
        <Route path="/Default/LaunchMessage/:documentId/:fileName/:launchDate" element={<LaunchMessage />} />
        <Route path="/Default/NoInternet/:documentId" element={<NoInternet />} />
        <Route path="/Default/NoLongerAvailable/:documentId" element={<NoLongerAvailable />} />
        <Route path="/Default/Printing/:documentId" element={<Printing />} />
        <Route path="/Default/Restricted/:documentId" element={<Restricted />} />
        <Route path="/Default/DocumentAccess/:documentId" element={<DocumentAccess />} /> 
        <Route path="/Default/BotMessage/:documentId" element={<BotMessage />} /> 
        <Route path="/Default/BotMessage/:documentId/:fileName" element={<BotMessage />} />
        <Route path="/Default/Restricted/:documentId/:fileName" element={<Restricted />} />
        <Route path="/Default/DocumentAccess/:documentId/:fileName" element={<DocumentAccess />} />
        <Route path="/Default/ReaderAccess/:documentId/:fileName" element={<ReaderAccess />} />
        <Route path="/Default/SessionExpireMessage/:documentId/:level/:fileName" element={<SessionExpire />} />
        <Route path="/Default/NoDocument/:documentId/:fileName" element={<NoDocument />} />
        <Route path="/Default/NoPlan/:documentId/:fileName" element={<NoPlan />} />
        <Route path="/Default/MaxReadDocument/:documentId/:fileName" element={<MaxReadDocument />} />
        <Route path="/Default/SecurityAlert/:documentId/:fileName" element={<SecurityAlert />} />
        <Route path="/Default/AccessDenied/:documentId/:fileName" element={<AccessDenied/>} />
        
        <Route path="/Xerox/Error/:documentId" element={<XeroxError />} />
        <Route path="/Xerox/MaxReadMessage/:documentId/:fileName" element={<XeroxMaxReadMessage />} />
        <Route path="/Xerox/NoAccess/:documentId/:fileName" element={<XeroxNoAccessMessage />} />
        <Route path="/Xerox/ExpireMessage/:documentId/:fileName" element={<XeroxExpireMessage />} />
        <Route path="/Xerox/LaunchMessage/:documentId/:fileName/:launchDate/:launchTime" element={<XeroxLaunchMessage />} />
        <Route path="/Xerox/LaunchMessage/:documentId/:fileName/:launchDate" element={<XeroxLaunchMessage />} />
        <Route path="/Xerox/NoInternet/:documentId" element={<XeroxNoInternet />} />
        <Route path="/Xerox/NoLongerAvailable/:documentId" element={<XeroxNoLongerAvailable />} />
        <Route path="/Xerox/Printing/:documentId" element={<XeroxPrinting />} />
        <Route path="/Xerox/Restricted/:documentId" element={<XeroxRestricted />} />
        <Route path="/Xerox/DocumentAccess/:documentId" element={<XeroxDocumentAccess />} />
        <Route path="/Xerox/BotMessage/:documentId" element={<XeroxBotMessage />} />

        <Route path="/Xerox/ReaderAccess/:documentId/:fileName" element={<XeroxReaderAccess />} />

        <Route path="/Xerox/Restricted/:documentId/:fileName" element={<XeroxRestricted />} />
        <Route path="/Xerox/DocumentAccess/:documentId/:fileName" element={<XeroxDocumentAccess />} />
        <Route path="/Xerox/BotMessage/:documentId/:fileName" element={<XeroxBotMessage />} />
        <Route path="/Xerox/SessionExpireMessage/:documentId/:level/:fileName" element={<XeroxSessionExpire />} /> 
        <Route path="/Xerox/NoDocument/:documentId/:fileName" element={<XeroxNoDocument />} />
        <Route path="/Xerox/NoPlan/:documentId/:fileName" element={<XeroxNoPlan />} />
        <Route path="/Xerox/MaxReadDocument/:documentId/:fileName" element={<XeroxNoMaxReadDocument />} />
      </Route>
    </Routes>
  </BrowserRouter>
  // </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();